import React from "react";
import "./accommodationUnitCard.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarMinus } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { IAccommodationAmenity } from "pages/secure/facility/accommodation/amenities/Amenities";
import { allIcons } from "components/IconSelector/iconSelector";
import { ButtonNew } from "components/buttonNew";

export interface IAccommodationUnitCardProps {
  accommodationType: string; // e.g., "Hotel"
  title: string; // e.g., "Studio"
  bedDetails?: string; // e.g., "1 queen bed"
  capacity: string; // e.g., "2 people"
  amenities?: IAccommodationAmenity[]; // e.g., [{title: "Mini-fridge", icon: "fridge"}]
  price: number; // nightly base price
  imageUrl?: string; // optional image
  isSoldOut?: boolean;
  nextAvailableDate?: string;
}

const AccommodationUnitCard: React.FC<IAccommodationUnitCardProps> = ({
  accommodationType,
  title,
  bedDetails,
  capacity,
  amenities,
  price,
  imageUrl,
  isSoldOut,
  // nextAvailableDate,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("property-unit-card", { "property-unit-card--sold-out": isSoldOut })}>
      {/* Image Section */}
      <div className="property-unit-card__image-wrapper">
        {imageUrl ? (
          <img src={imageUrl} alt={title} className="property-unit-card__image" />
        ) : (
          <div className="property-unit-card__image placeholder">
            <span>No image</span>
          </div>
        )}
      </div>

      {/* Main Content */}
      <div className="property-unit-card__details">
        <div>
          <span className="property-unit-card__tag">{accommodationType}</span>
        </div>

        <p className="property-unit-card__title">{title}</p>

        <p className="property-unit-card__description">
          {bedDetails} • {capacity}
        </p>

        {amenities && (
          <div className="property-unit-card__amenities">
            {amenities.map((amenity, index) => (
              <span key={index} className="property-unit-card__amenity-chip">
                {amenity?.icon && allIcons[amenity?.icon] && (
                  <FontAwesomeIcon icon={allIcons[amenity?.icon]} style={{ fontSize: "10px" }} />
                )}
                {amenity?.title}
              </span>
            ))}
          </div>
        )}
      </div>

      {/* Price Section */}
      <div className="property-unit-card__price-section">
        {isSoldOut ? (
          <p className="property-unit-card__sold-out-text">
            <FontAwesomeIcon icon={faCalendarMinus} style={{ fontSize: "18px" }} />
            {t("Sold out")}
          </p>
        ) : (
          <>
            <p className="property-unit-card__price">
              ${price}
              <span className="property-unit-card__price-unit"> /night</span>
            </p>
            <p className="property-unit-card__sub-info">{t("plus taxes & fees")}</p>

            <ButtonNew size="small" type="primary" className="mt-2">{t("Select unit")}</ButtonNew>
          </>
        )}
      </div>
    </div>
  );
};

export default AccommodationUnitCard;
